<template>
     <!--==========================================-->
         <div class="flex flex-col h-full w-full bg-warmGray-100">
             <div class="w-full sticky bottom-0 bottom-0 w-md text-warmGray-900 font-medium">
                <div class="w-full  my-2 flex flex-col space-y-3">
                    <!---========-->
                    <div class="flex px-4 py-3 shadow-sm">
                    <p class="w-3/4 my-auto text-warmGray-600 font-semibold ">Zwischensumme: </p>
                    <p class="m-auto">{{ numeralFormat(cartTotal, '0,00[.]00 $') }} </p>

                    </div>
                    <!---========-->
                      <div class="flex   px-4 py-3 shadow-sm">
                    <p class="w-3/4 my-auto text-warmGray-600 font-semibold ">Lieferkosten: </p>
                    <p class="m-auto">{{numeralFormat(lieferkosten, '0,00[.]00 $') }} </p>

                    </div>
                    <!---========-->
                    <div class="flex px-4 py-3 shadow-sm">
                    <p class="w-3/4 my-auto text-warmGray-600 font-semibold ">Gesammt: </p>
                    <!-- <p class="m-auto">{{ numeralFormat(grantTotal, '0,00[.]00 $') }} </p> -->
                    <p class="m-auto">{{ numeralFormat(getTotalCost, '0,00[.]00 $') }} </p>
                   </div>
                  <!---========-->
                  </div>
                  <router-link
                   class=" bottom-2 w-full  m-auto"
                    :to="{
                    name: 'checkout',
                    params:{slug: 'checkout'}
                    }"
                   >
                    <button class="w-full bg-namasteBlue  m-auto
                      font-medium p-3  text-white  text-center rounded-md"
                     :disabled="disabled" v-bind:class="{ 'bg-warmGray-200': disabled}"
                      @click="dontShowHeader()"
                      >
                        <p class="text-2xl  font-medium"> Bestellen</p>
                    </button>
                    </router-link>
             </div>
         </div>

</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    disabled: Boolean
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      cartTotal: 'getFormCartTotal',
      basketItems: 'getCartProducts',
      totalCartItems: 'getTotalCartItems',
      lieferkosten: 'getLieferKosten',
      getPopupCart: 'getPopupCart',
      getTotalCost: 'getGesammtKosten'
    }),
    grantTotal () {
      return this.lieferkosten + this.cartTotal
    }
  },
  methods: {
    ...mapActions({
      dontShowHeader: 'dontShowHeader'
    })
  }
}
</script>
<style scoped>
   .stickyButton{
      position: -webkit-sticky;
      align-self: flex-start;
      position: sticky;
      bottom: 0px !important;
   }

</style>
